import '../ModemSettings.css';
import { useState, useEffect, ReactNode } from 'react'
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Switch from "react-switch";
import { ModemData } from '../../../api/Drone';
import { APIRequestPost } from '../../../utils/APIRequests';
import { NebosvodGetTokenRequestData, NebosvodSaveNebosvodModemInfoRequestData } from '../../../api/Nebosvod';

interface NebosvodSettingsProps {
    drone: ModemData;
    isNebosvodAuth: boolean;
    nebosvodAuthLogin: string;
    onNebosvodAuth: (login: string) => void;
}

function NebosvodSettings({ drone, isNebosvodAuth, nebosvodAuthLogin, onNebosvodAuth }: NebosvodSettingsProps): ReactNode {
    const { t } = useTranslation(['modem']);

    const [nebosvodModemSaveInfo, setNebosvodModemSaveInfo] = useState<string>("");
    const [isNebosvodVis, setIsNobosvodVis] = useState<boolean>(drone.nebosvodInfo?.isVis ?? false);
    const [_nebosvodOprtnId, setNebosvodOprtnId] = useState<string>(drone.nebosvodInfo?.oprtnId ?? "");
    const [nebosvodSerNum, setNebosvodSerNum] = useState<string>(drone.nebosvodInfo?.serNum ?? "");
    const [nebosvodRegIndex, setNebosvodRegIndex] = useState<string>(drone.nebosvodInfo?.regIndex ?? "");
    const [nebosvodLogin, setNebosvodLogin] = useState<string>("");
    const [nebosvodPass, setNebosvodPass] = useState<string>("");
    const [nebosvodSaveInfo, setNebosvodSaveInfo] = useState<string>("");

    useEffect(() => {
        setIsNobosvodVis(drone.nebosvodInfo?.isVis ?? false);
        setNebosvodOprtnId(drone.nebosvodInfo?.oprtnId ?? "");
        setNebosvodSerNum(drone.nebosvodInfo?.serNum ?? "");
        setNebosvodRegIndex(drone.nebosvodInfo?.regIndex ?? "");
    }, [drone]);

    function nebosvodLogOut(): void {
        APIRequestPost('/nebosvod/logOut', {
            logSuccess: true
        }).then(() => {
            window.location.reload();
        }).catch(() => {
            setNebosvodModemSaveInfo(t('logout_error').toString());
        });
    }

    function switchNebosvodVis(): void {
        setIsNobosvodVis(!isNebosvodVis)
    }

    function saveNebosvodModemInfo(): void {
        const data: NebosvodSaveNebosvodModemInfoRequestData = {
            serNum: nebosvodSerNum,
            regIndex: nebosvodRegIndex,
            oprtnId: nebosvodSerNum,
            imei: drone.imei,
            isVis: isNebosvodVis
        };

        APIRequestPost('/nebosvod/saveNebosvodModemInfo', {
            data: data,
            logSuccess: true
        }).then(() => {
            setNebosvodModemSaveInfo(t('successfully').toString());
        }).catch(() => {
            setNebosvodModemSaveInfo(t('login_or_pass_error').toString());
        });
    }

    function loginNebosvod(): void {
        const data: NebosvodGetTokenRequestData = {
            login: nebosvodLogin,
            password: nebosvodPass
        };

        APIRequestPost('/nebosvod/getToken', {
            data: data,
            logSuccess: true
        }).then(() => {
            setNebosvodSaveInfo(t('successfully').toString());
            onNebosvodAuth(nebosvodLogin);
        }).catch(() => {
            setNebosvodSaveInfo(t('error').toString());
        });
    }

    return (
        <div className='nebosvod'>
            {isNebosvodAuth ? (
                <>
                    <div className='t-18 ts-16'>Логин в системе <a href='https://skyarc.ru/' target="_blank" rel="noopener">Небосвод:</a> {nebosvodAuthLogin}</div>
                    <div className='settings-grid ts-35'>
                        <Button onClick={nebosvodLogOut}>Выход</Button>
                    </div>

                    <div className='t-18 ts-16'>Серийный номер по CTA-2063-A или в формате производителя: </div>
                    <div className='settings-grid ts-40'>
                        <div className='grid-1-4'>
                            <Form.Control
                                type="text"
                                placeholder={nebosvodSerNum}
                                onChange={(event) => { setNebosvodSerNum(event.target.value) }}
                            />
                        </div>
                    </div>
                    <div className='t-18 ts-16'>Регистрационный знак или учетный номер БВС: </div>
                    <div className='settings-grid ts-16'>
                        <div className='grid-1-4'>
                            <Form.Control
                                type="text"
                                placeholder={nebosvodRegIndex}
                                onChange={(event) => { setNebosvodRegIndex(event.target.value) }}
                            />
                        </div>
                    </div>

                    <div className='settings-grid ts-16'>
                        <Button onClick={saveNebosvodModemInfo}>Сохранить</Button>
                        <div className='grid-ogn'>
                            <div className='ogn-switch'>
                                <Switch
                                    onChange={() => { switchNebosvodVis() }}
                                    checked={isNebosvodVis}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    onColor='#EBFF00'
                                    onHandleColor='#000000'
                                    offHandleColor='#000000'
                                    offColor='#494949'
                                />
                            </div>
                            <div className='t-18'>
                                Отправлять данные в систему "Небосвод"
                            </div>
                        </div>
                    </div>
                    <div className='t-18 ts-16'>{nebosvodModemSaveInfo}</div>
                </>
            ) : (
                <>
                    <div className='t-18 ts-16'>Введите данные системы <a href='https://skyarc.ru/' target="_blank" rel="noopener">Небосвод:</a> </div>
                    <div className='t-18 ts-16'>Логин: </div>
                    <div className='settings-grid ts-16'>
                        <div className='grid-1-4'>
                            <Form.Control
                                type="text"
                                placeholder={nebosvodLogin}
                                onChange={(event) => { setNebosvodLogin(event.target.value) }}
                            />
                        </div>
                    </div>
                    <div className='t-18 ts-16'>Пароль: </div>
                    <div className='settings-grid ts-16'>
                        <div className='grid-1-4'>
                            <Form.Control
                                type="password"
                                placeholder={nebosvodPass}
                                onChange={(event) => { setNebosvodPass(event.target.value) }}
                            />
                        </div>
                    </div>
                    <div className='settings-grid ts-35'>
                        <Button onClick={loginNebosvod}>Войти</Button>
                    </div>
                    <div>{nebosvodSaveInfo}</div>
                </>
            )}
        </div>
    )
}

export default NebosvodSettings;